/**
 * 라인시트 상품과 짝이 되는 오더시트 상품을 찾는다 — **상품 id 로**.
 *
 * 주문서 화면은 두 응답(라인시트 상품 목록, 오더시트 상품 목록)을 합쳐서 그린다. 예전에는 두 목록의
 * 같은 순번끼리 짝지었는데, 두 목록의 상품 수가 다르면 그 지점 뒤로 전부 한 칸씩 밀려 남의
 * 공급가·컨디션·주문 수량이 붙는다. 실제로 바이어에게는 재고가 전부 0 인 상품이 라인시트 목록에서만
 * 빠지고 오더시트 목록에는 남아 있어서(서버의 두 조회가 옵션을 거르는 조건이 다르다), 그런 상품이
 * 있는 시트에서는 공급가가 컨디션과 맞지 않게 나왔다(2026-09-30, 오더시트세트 25162 —
 * 라인시트 1,516개 / 오더시트 1,968개).
 *
 * 오더시트 상품의 id 는 라인시트 상품 id 와 같은 값이다. 응답에 id 가 하나도 없을 때만(그런 응답을
 * 주는 옛 API 를 위해) 순번으로 되돌아간다.
 */
export function createOrderSheetProductFinder<T extends { id?: number | null }>(
  orderSheetProducts: T[] | null | undefined
): (lineSheetProduct: { id: number }, index: number) => T | undefined {
  const products = orderSheetProducts ?? [];
  const byId = new Map<number, T>();
  products.forEach((product) => {
    if (product && typeof product.id === "number") {
      byId.set(product.id, product);
    }
  });

  if (byId.size === 0) {
    return (_lineSheetProduct, index) => products[index];
  }
  return (lineSheetProduct) => byId.get(lineSheetProduct.id);
}
